module.exports = __webpack_public_path__ + "media/stylesheets/images/marker-icon-2x-violet-5e1f480fccccb037f5075e206529a988.png";